import React from 'react'
import './styles.scss'
import { config } from './config'

export const MetaInfos = ({ authors, updated }: MetaInfosProps) => (
  <div className='ta metainfo'>
    <div className='ta author'>
      {authors.map((author, i) => {
        return (
          <React.Fragment key={i}>
            <span>{author}</span>
            {i < authors.length - 1 && <>, </>}
          </React.Fragment>
        )
      })}
    </div>
    {updated && <div className='ta updated'>Aktualisiert am {updated}</div>}
  </div>
)
